<script>
import MetersComponent from "./MetersComponent.vue";
import ActionButtons from "../ProductSearch/ActionButtons.vue";
import {UsedProcutSaleType} from "../../data/we_enums";
import {defaultStrings} from "../../data/strings";
import { createSeePriceParamsClicked } from "../../data/OnLoginActionParams";

export default {
  name: "UsedCard",
  components: {MetersComponent, ActionButtons},
  props: ['slide', 'index', 'type'],
  data() {
    return {
      customFlags: {
        tech: 'Tech Reviewed',
        video: 'Video',
      },
    }
  },
  computed: {
    imageUrl() {
      const url = this.slide.primary_image_url;
      if (!url) {
        return '';
      }

      // only target the MachineFinder CDN URLs
      if (
        url.includes('photos.machinefinder.com') &&
        (url.includes('_huge_') || url.includes('_large_'))
      ) {
        // replace either “_huge_” or “_large_” with “_gallery_”
        return url.replace(/_(?:huge|large)_/, '_gallery_');
      }

      // fallback to whatever URL was provided
      return url;
    },
    categoryLink() {
      if (!this.slide.category.industries) {
        return null;
      }

      const industry = this.slide.category.industries[0];

      if (!industry) {
        return `/used-equipment?industry=${encodeURIComponent(this.slide.category.label)}`;
      }

      return `/used-equipment?industry=${encodeURIComponent(industry.name)}&categories%5B%5D=${encodeURIComponent(this.slide.category.label)}`;
    },
    algoliaLink() {
      if (!this.slide.industry) {
        return null;
      }

      const industry = this.slide.industry[0];

      if (!industry) {
        return `/used-equipment?industry=${encodeURIComponent(this.slide.category)}`;
      }

      return `/used-equipment?industry=${encodeURIComponent(industry)}&categories%5B%5D=${encodeURIComponent(this.slide.category)}`;
    },
    isWarranty() {
      return this.slide.warranties ? Object.keys(this.slide.warranties).length : false;
    },
    isGuest() {
      return this.$store.getters['user/isGuest']
    },
    saleTypes() {
      return UsedProcutSaleType;
    },
    saleShowOnlyForCustomer(){
      return this.slide.show_sale_price_only_for_customers || false
    },
    saleButtonToLoginLabel() {
      if (this.slide.sale_login_button_label){
        return this.slide.sale_login_button_label
      }

      return defaultStrings.sale_button_login_label
    },
    leasePrices() {
      return [
        {period: 'yr', value: this.slide.display_y_lease_price},
        {period: 'mo', value: this.slide.display_m_lease_price},
        {period: 'hr', value: this.slide.display_h_lease_price},
      ].filter(i => i.value);
    },
    isLease() {
      return this.slide.sale_type === UsedProcutSaleType.LEASE;
    },
    salePriceLabel() {
      let label = ""
      if (this.slide.sale_type == UsedProcutSaleType.WAS_NOW){
        label = "Special Pricing"
      } else if (this.slide.sale_type == UsedProcutSaleType.WAS_CASH_NO_TRADE){
        label = "CASH/NO TRADE"
      } else if (this.slide.sale_type == UsedProcutSaleType.LEASE){
        label = UsedProcutSaleType.LABEL_DEFAULT_LEASE;
      }

      if (this.isGuest && this.slide.sale_price_label_guest) {
        label = this.slide.sale_price_label_guest
      } else if (!this.isGuest && this.slide.sale_price_label_customer){
        label = this.slide.sale_price_label_customer
      }

      return label
    },
    normalizeCity() {
      if (!this.slide.city) {
        return;
      }

      return this.slide.city.charAt(0).toUpperCase() + this.slide.city.slice(1).toLowerCase();
    },
    promoLink() {
      const promo = this.slide.promos.find(i => i.link_title);

      return promo ? promo.link_title : 'Promo';
    },
    isNew() {
      return this.type === 'new';
    },
    categoriesForNew() {
      // const sliced = this.slide.category.slice(0, 2);
      //
      // return sliced.join(', ');
      return this.slide.model_info;
    },
    url() {
      return !this.isNew ? `/products/used/${this.slide.machine_id}`: `/products/new/${this.slide.sku}`;
    },
    categoryTitle() {
      if (!this.slide.category) {
        return null;
      }

      if (this.slide.category instanceof Object) {
        return this.slide.category.title;
      }

      return this.slide.category;
    },
    isSpecs() {
      return !!Object.keys(this.slide.specs).length
    },
    flags() {
      const flags = [
        {
          isActive: !!this.slide.video_url,
          type: this.customFlags.tech,
          isCustom: true,
        },
        {
          isActive: this.slide.promos_count || this.slide.has_promo,
          isCustom: false,
          classList: 'green',
          title: this.promoLink,
        },
        {
          isActive: this.slide.is_clearance && !this.isLease,
          isCustom: false,
          classList: 'red',
          title: 'Sale',
        },
        {
          isActive: this.isWarranty,
          isCustom: false,
          classList: '!bg-black !text-white',
          title: 'Warranty',
        },
        {
          isActive: this.slide.sale_pending,
          isCustom: false,
          classList: 'yellow',
          title: 'Sale Pending',
        },
        {
          isActive: this.slide.listing_video_host === 'vimeo' || this.slide.listing_video_host === 'youtube',
          type: this.customFlags.video,
          isCustom: true,
        },
      ];

      return flags.filter(f => f.isActive).slice(0, 4);
    },

    analyticsData() {
      if (this.isNewType){
        return {
          equipmentType: 0,
          model: `John Deere ${this.slide.model_number}`,
          stockNumber: undefined,
          sku: this.slide.sku,
          categoryTitle: category,
          url: `${window.location.origin}/products/new/${this.slide.sku}`
        }
      } else {
        return {
          equipmentType: 1,
          model: this.slide.model_info,
          stockNumber: this.slide.stock_number,
          sku: undefined,
          categoryTitle: this.slide.category.label || this.slide.category,
          url: `${window.location.origin}/products/used/${this.slide.machine_id}`
        }
      }
    }
  },
  methods: {
    openLogin(){
      window.openLogin(createSeePriceParamsClicked(this.analyticsData), () => {})
    },
    replaceTag(value) {
      return value.replace(new RegExp('<br/>', "gm"), ' / ');
    },
    sliceDesc(desc) {
      if (desc.length <= 100) {
        return desc;
      }

      return desc.slice(0, 93).concat(' ...');
    },
    addCommasToNumbers(num) {
      return num.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    getMetersString(meters) {
      const entity = meters[0];
      const capitalized = entity.key.charAt(0).toUpperCase() + entity.key.replace(/_/g, " ").slice(1);

      return `${capitalized}: ${this.addCommasToNumbers(entity.value)} ${entity.units}`;
    },
    onNavToCategory(event) {
      const a = $(event.target).closest("a")
      let url = a.attr("href");

      if (!url.startsWith('http')){
        url = window.location.origin + url
      }

      let industry = null
      if (this.slide.category.industries) {
        industry = this.slide.category.industries[0]
      }

      if (!industry && this.slide.industry) {
        industry = this.slide.industry[0];
      }

      let categoryTitle = this.categoryTitle

      if (industry){
        categoryTitle += ` (${industry})`
      }

      this.$store.dispatch("analytics/onCategoryClicked", {
        equipmentType: this.type === "new" ? 0 : 1,
        categoryTitle, url
      })

      if (event.metaKey || event.ctrlKey || event.button === 1) {
        window.open(url, "_blank");
      } else {
        window.location.href = url
      }
    },
  },
}
</script>

<template>
  <div class="h-120 relative flex flex-col justify-between w-full mx-0 md:mx-auto lg:mx-0 bg-white border-2 border-gray-200 rounded-lg shadow-md">
    <a :href="url" class="flex-initial">
      <img class="w-full !h-44 object-cover" :src="imageUrl" alt="inventory image" loading="lazy">
    </a>

    <div class="grow px-4 py-2">
      <div v-if="!isNew" class="flex flex-col">
        <div v-if="categoryLink" class="flex flex-col mb-2">
          <a :href="categoryLink" class="self-start border border-green-500 text-green-500 text-xs uppercase border-we-light border p-1 px-3 rounded-xl leading-none w-fit max-w-max"
             @click.prevent="onNavToCategory($event)">
            <p class="!text-we-light !m-0 text-xs uppercase">{{ categoryTitle }}</p>
          </a>
        </div>
        <div v-if="algoliaLink" class="flex flex-col mb-2">
          <a :href="algoliaLink" class="self-start border border-green-500 text-green-500 text-xs uppercase border-we-light border p-1 px-3 rounded-xl leading-none w-fit max-w-max"
             @click.prevent="onNavToCategory($event)">
            <p class="!text-we-light !m-0 text-xs uppercase" v-html="categoryTitle"></p>
          </a>
        </div>
        <span class="text-normal mb-0 font-semibold text-gray-900" v-html="slide.model_info"></span>
        <template v-if="slide.sale_type != saleTypes.NO_SALE">
          <div v-if="!saleShowOnlyForCustomer || (saleShowOnlyForCustomer && !isGuest)">
            <template v-if="slide.sale_type !== saleTypes.LEASE">
              <p class="text-we-light m-0 text-xs font-bold line-through">{{ slide.display_price }}</p>
            </template>
            <template v-if="slide.sale_type === saleTypes.LEASE && slide.is_advertised_price">
              <p class="text-we-light mb-1 text-lg font-semibold mt-1">{{ slide.display_price }}</p>
            </template>
            <span class="text-[10px] text-white font-bold border border-we-light rounded-md bg-we-light p-1 pr-2 pl-2">{{salePriceLabel}}</span><br/>
            <template v-if="!isLease">
              <p class="text-we-light m-0 text-lg font-bold">{{ slide.display_sale_price }}</p>
            </template>
            <template v-else>
              <div v-for="entity in leasePrices" class="flex flex-row space-x-2">
                <p class="text-we-light m-0 text-lg font-bold">{{ entity.value }}/<span>{{entity.period}}</span></p>
              </div>
            </template>
          </div>

          <div v-else-if="saleShowOnlyForCustomer && isGuest">
            <div class="text-we-light m-0 font-bold flex items-center">
              <template v-if="slide.sale_type !== saleTypes.LEASE">
                <p class="text-we-light m-0 text-xs font-bold line-through">{{ slide.display_price }}</p>
              </template>
              <template v-if="slide.sale_type === saleTypes.LEASE && slide.is_advertised_price">
                <p class="text-we-light mb-1 text-lg font-semibold mt-1">{{ slide.display_price }}</p>
              </template>
              <a href="/customer/login" @click.prevent="openLogin" class="text-we-light px-1 py-[3px] ml-2 border border-we-light hover:border-we rounded-md inline-flex items-center">
                <span class="text-[10px]">{{saleButtonToLoginLabel}}</span>
                <svg width="9" height="13" viewBox="0 0 9 13" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'ml-1 text-we-light svg-we-light w-[10px] h-[10px]'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M.557.808a.744.744 0 00-.213.03.604.604 0 00-.18.087C.054 1.004 0 1.1 0 1.213c0 .113.055.208.164.287l7.475 5.343-7.377 5.274c-.109.078-.164.172-.164.281 0 .11.055.203.164.281.11.078.243.118.402.118.158 0 .292-.04.402-.118l7.77-5.554c.11-.079.164-.172.164-.282 0-.109-.055-.203-.164-.28L.951.924A.59.59 0 00.762.838a.772.772 0 00-.205-.03z" fill="#26282A" fill-rule="evenodd"/></svg>
              </a>
            </div>
          </div>

          <p v-else class="text-we-light mb-1 text-lg font-semibold mt-1">{{ slide.display_price }}</p>
        </template>

        <p v-else class="text-we-light mb-1 text-lg font-semibold mt-1">{{ slide.display_price }}</p>
      </div>

      <div v-else class="flex flex-col">
        <span class="text-xs mb-1 uppercase text-gray-900" v-html="categoriesForNew"></span>
        <span class="text-normal mb-0 font-semibold text-gray-900" v-html="`John Deere ${slide.model_number}`"></span>
      </div>
      <p v-if="slide.meters && slide.meters.length" class="flex items-center text-base leading-6 mb-1 text-gray-700 mt-1">
        <meters-component :meters="slide.meters"></meters-component>
      </p>
      <p v-if="normalizeCity" class="flex items-center text-base leading-6 mb-1 text-gray-700 mt-1">
        <img class="h-4 w-4 mr-2" src="/svg/icons/we_location.svg" />
        <span>{{normalizeCity}}, {{slide.state}}</span>
      </p>
      <p v-if="slide.stock_number" class="flex items-center text-base leading-6 mb-1 text-gray-700 mt-1">
        <img class="h-4 w-4 mr-2" src="/svg/icons/we_serial_number.svg" />
        <span>{{slide.stock_number}}</span>
      </p>
      <div v-if="isNew && isSpecs" class="flex flex-col">
        <div v-for="spec in slide.specs" class="flex items-center text-base leading-6 mb-1 text-gray-700 mt-1">
          <span v-if="spec.value && spec.name" class="font-normal text-sm"> <b>{{spec.name}}: </b>{{ replaceTag(spec.value) }}</span>
        </div>
      </div>
    </div>
    <action-buttons class="flex-initial" :item="slide" :product_type="type" :i-key="index"></action-buttons>
    <div class="flex-initial py-2 px-4">
      <a :href="url" class="flex justify-center w-full px-4 py-2 bg-we-light text-white font-bold rounded-lg">VIEW</a>
    </div>
    <div class="absolute w-full h-auto product-tags">
      <template v-for="flag in flags">
        <template v-if="!flag.isCustom">
          <div class="product-tag" :class="flag.classList">{{ flag.title }}</div>
        </template>
        <template v-else>
          <div class="product-tag yellow" v-if="flag.type === customFlags.video">
            <a
              v-if="slide.listing_video_host === 'vimeo'"
              class="video magnetic-popup-video" :href="'https://player.vimeo.com/video/' + slide.listing_video_id"
            >
              Video <span>&#x25BE;</span>
            </a>
            <a
              v-if="slide.listing_video_host === 'youtube'"
              class="video magnetic-popup-video" :href="'https://www.youtube.com/watch?v=' + slide.listing_video_id"
            >
              Video <span>&#x25BE;</span>
            </a>
          </div>

          <div class="!bg-white product-tag !pl-4 flex items-center" v-if="flag.type === customFlags.tech">
            <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="1400" height="1400" viewBox="0 0 1400 1400" v-bind:svg-inline="''" v-bind:class="'mr-2 h-[20px] w-auto rotate-[-5deg]'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><defs><clipPath id="a"><path fill="none" d="M0 0h1400v1400H0z"/></clipPath></defs><g clip-path="url(#a)"><path fill="#231f20" d="M1291.83 769.67l.07-139.03-168.6-45.33a437.196 437.196 0 00-43.22-104.41l87.34-151.21-98.26-98.36-151.3 87.19c-32.41-18.68-67.42-33.35-104.36-43.32l-45.15-168.65-139.03-.07-45.33 168.6a436.954 436.954 0 00-104.4 43.22l-151.21-87.34-98.36 98.26 87.19 151.3a437.365 437.365 0 00-43.33 104.36l-168.65 45.15-.07 139.03 168.6 45.33a436.954 436.954 0 0043.22 104.4L229.63 1070l98.26 98.36 151.3-87.19c32.41 18.68 67.42 33.35 104.36 43.32l45.15 168.65 139.03.07 45.33-168.6a436.954 436.954 0 00104.4-43.22l151.21 87.34 98.36-98.25-87.19-151.3c18.68-32.41 33.35-67.42 43.32-104.36l168.65-45.15zm-593.42 169.8c-132.34-.07-239.57-107.41-239.5-239.75.07-132.34 107.41-239.57 239.75-239.5 132.34.07 239.57 107.41 239.5 239.75-.07 132.34-107.41 239.57-239.75 239.5"/><path fill="#fd0" d="M698.41 940.25c-132.56-.07-240.34-107.97-240.27-240.52.07-132.56 107.97-240.34 240.52-240.28 132.56.07 240.34 107.97 240.28 240.52-.07 132.56-107.97 240.34-240.53 240.27m.24-451.97c-116.66-.06-211.62 94.8-211.68 211.46-.06 116.66 94.8 211.62 211.46 211.68 116.66.06 211.62-94.8 211.68-211.46.06-116.66-94.8-211.62-211.46-211.68"/><path fill="#086c00" d="M800.23 514.36l-250.18 216.6S226.44 429.39 186.43 394.32l384.59 643.58s248.96-324.46 322.03-421.26c-18.69-43.53-51.58-79.57-92.82-102.27M1094.85 257.19l199.98-170.03-158.16 211.89c-13.87-13.97-27.85-28-41.82-41.86"/></g></svg>
            <span class="text-we-light font-bold">Tech Reviewed</span>
          </div>
        </template>
      </template>
    </div>
  </div>
</template>

<style scoped>
.svg-we-light path {
  fill: #367C2C;
}
</style>



// WEBPACK FOOTER //
// resources/js/Components/new/UsedCard.vue